import React, { useCallback, useEffect, useMemo, useState } from 'react';

import {
    ColumnDef, Row, Header,
    flexRender,
    getCoreRowModel,
    getExpandedRowModel,
    useReactTable
} from '@tanstack/react-table';

import {
    KeyboardSensor,
    MouseSensor,
    TouchSensor, type DragEndEvent, useSensor,
    useSensors, DndContext,
    closestCenter
} from '@dnd-kit/core';
import {
    arrayMove,
    SortableContext,
    verticalListSortingStrategy
} from '@dnd-kit/sortable';

import StageByTaskView from './StageByTaskView';
// needed for row & cell level scope DnD setup
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Badge, Box, Button, Divider, Flex, Paragraph, Spinner, Text, useColorMode } from 'theme-ui';
import { useLocation, useSearchParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import TablePagination from '../../Tabels/Pagination';
import queryString from 'query-string';
import { TabelClassname } from '../../../utils/Classname';
import CommentPopup from '../demotable/CommentPopup';
import FilterPopup from '../../forms-component/filterPopup';
import { TabelHeadingTxt } from '../../Text/TabelCommonTxt';
import { useDispatch } from 'react-redux';
import { formatDueDate, getApiEndPoint, msToTime, removeDuplicateQueryParams } from '../../../utils/GenerateQueryString';
import { GetAllStageView, GetAllStageViewSuccess, UpdateStageRow, getAllTaskViewByStage, getStageByCustomOrder, getStageTimeSummery } from '../../../store/actions/project.action';
import { getAllUserWithoutPagination } from '../../../store/actions/user.action';
import CommentsDialogBox from '../demotable/CommentSection';
import { useQuery } from '@tanstack/react-query';
import { baseUrl } from '../../../utils/global';
import { FaAngleDown, FaAngleUp } from 'react-icons/fa';
import { restrictToVerticalAxis } from '@dnd-kit/modifiers';
import clockIcon from "../../../Components/assets/images/Icon/Clock.svg";

import toast from 'react-hot-toast';
import { statusColors, promise as promiseOptions } from '../../../utils/constent';
import { StageName } from './StageName';
import theme from '../../../theme';
import GeneralTimerStart from '../TaskView/GeneralTimerModal/GeneralTimerStart';
import { RootState, stageData, ISalesRepInfo, usersProps } from '../../../../@types';
import { getUserbyToken } from '../../../store/actions/login.action';
import CommonExportModal from '../../Modals/CommonExportModal';

type SortableAttributes = ReturnType<typeof useSortable>['attributes'];
type SortableListeners = ReturnType<typeof useSortable>['listeners'];

const RowDragContext = React.createContext<{ attributes: SortableAttributes | Record<string, never>; listeners: SortableListeners }>({
    attributes: {} as SortableAttributes,
    listeners: undefined,
});

// Cell Component
const RowDragHandleCell = ({ row }: { row: Row<stageData> }) => {
    const [colorMode] = useColorMode();
    const { attributes, listeners } = React.useContext(RowDragContext);

    return (
        <button {...attributes} {...listeners} style={{ border: "none", backgroundColor: "transparent", color: colorMode === "light" ? "#000000" : "#ffffff", cursor: "grab" }}>
            🟰 #{window.location.href?.includes("CustomOrder1") ? row.original?.order1 : row.original?.order2}
        </button>
    )
}


const DraggableRow = React.memo(({ row }: { row: Row<stageData> }) => {
    const commonPadding = useMemo(() => localStorage.getItem("tPadding") || '13px', []);

    const { transform, transition, setNodeRef, isDragging, attributes, listeners } = useSortable({
        id: row.original._id,
    });

    const style = useMemo(() => ({
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.8 : 1,
        zIndex: isDragging ? 1 : 0,
        position: 'relative' as const,
    }), [transform, transition, isDragging]);
    const [colorMode] = useColorMode();

    return (
        <RowDragContext.Provider value={{ attributes, listeners }}>
            <tr ref={setNodeRef} style={style} data-state={row.getIsSelected() ? "selected" : undefined}
                className={`table-hover-row ${colorMode === "light" ? "light-mode" : "dark-mode"}`}
            >
                {row.getVisibleCells().map((cell, cellIndex) => (
                    <td
                        key={cell.id}
                        className={`fixed-column-${cellIndex} table-cell`}
                        style={{
                            padding: `${commonPadding}px`,
                            display: "gird",
                            placeContent: "center",
                            width: cell.column.getSize(),
                            background: colorMode === "light" ? "#fff" : "#282e42",

                            color: colorMode === "light" ? "#0a0a0a" : "#dadada"
                        }}
                    >
                        {flexRender(cell.column.columnDef.cell, cell.getContext())}
                    </td>
                ))}
            </tr>
        </RowDragContext.Provider>
    );
});


const StagesViewTwo: React.FC = () => {
    const commonPadding = localStorage.getItem("tPadding") || '13px';

    type YourDataType = {
        tasksNameList: {
            _id: string;
            color: string;
            name: string;
            shortForm: string;
        }[];
    };

    const location = useLocation();
    const [searchParams, setSearchParams] = useSearchParams({
        currentPage: "1",
        limit: "15",
    });

    const dispatch = useDispatch()
    const { stageView, loader, highlighters, timeTracking } = useSelector((state: RootState & { project: { stageView: { data: stageData[]; count: number }; loader: boolean; highlighters: Array<{ _id: string; name: string }>; timeTracking: unknown } }) => state.project);
    const { dataForTable, masterdataByKeys } = useSelector((state: RootState & { masterData: { dataForTable: { data: { allStages: Array<{ _id: string; name: string; isMEP?: boolean; isStructural?: boolean; isFireSprinkler?: boolean }>; allProjects: Array<{ _id: string; name: string }>; allProjectManagers: Array<{ _id: string; FirstName: string; LastName: string }> } }; masterdataByKeys: { data: { allDeliveredStages?: Array<{ _id: string; name: string }>; allRTDStages?: Array<{ _id: string; name: string }>; allDraftStages?: Array<{ _id: string; name: string }>; allProjects?: Array<{ _id: string; name: string }> } } } }) => state.masterData);
    const { userData } = useSelector((state: RootState) => state.user);
    const limit = parseInt(searchParams.get('limit') || "15");
    const currentPage = parseInt(searchParams.get('currentPage') || "1");
    const [actionOpen, setactionOpen] = useState(false);
    const [data, setData] = React.useState<stageData[]>([])
    const [stageDataId, setStageDataId] = useState('');
    const parsedQuery = queryString.parse(location.search);
    const [modalOpen, setModalOpen] = useState<boolean>(false);
    const { auther } = useSelector((state: RootState) => state.auth);
    const [selectedRows, setSelectedRows] = useState<string[]>([]);
    const [selectedRowsToExport, setSelectedRowsToExport] = useState<stageData[]>([]);
    const prevLocationRef = React.useRef<{ search: string; pathname: string } | null>(null);
    const [isExportModalOpen, setIsExportModalOpen] = useState<boolean>(false);

    useEffect(() => {
        dispatch(getAllUserWithoutPagination());
    }, [dispatch]);

    const authToken = localStorage.getItem("token")
    const toggleModal = () => {
        setModalOpen(!modalOpen);
        dispatch(getUserbyToken(authToken))

    };
    const handleClick = () => {
        setactionOpen(true)
    };

    const handleSelectStage = (stageId: string, isChecked: boolean) => {
        setSelectedRows(prev => {
            if (isChecked) {
                return [...prev, stageId];
            } else {
                return prev.filter(id => id !== stageId);
            }
        });
        setSelectedRowsToExport(prev => {
            if (isChecked) {
                const stage = stageView?.data?.find((item: stageData) => item._id === stageId)
                return stage ? [...prev, stage] : prev;
            } else {
                return prev.filter((item: stageData) => item?._id !== stageId);
            }
        });
    };

    const handleSelectAll = (isChecked: boolean) => {
        if (isChecked) {
            const allIds = stageView?.data?.map((item: stageData) => item._id) || [];
            setSelectedRows(allIds);
            setSelectedRowsToExport(stageView?.data || []);
        } else {
            setSelectedRows([]);
            setSelectedRowsToExport([]);
        }
    };

    useEffect(() => {
        if (stageDataId) {
            dispatch(getAllTaskViewByStage(stageDataId));
        }
    }, [stageDataId])
    const [isLoadingTrue, setIsLoadingTrue] = useState(false);
    const [colorMode] = useColorMode();

    const columns = useMemo<ColumnDef<stageData>[]>(() => [
        {
            id: 'select',
            header: ({ table }) => (
                <input
                    type="checkbox"
                    checked={selectedRows.length === (stageView?.data?.length || 0) && (stageView?.data?.length || 0) > 0}
                    onChange={(e) => handleSelectAll(e.target.checked)}
                />
            ),
            cell: ({ row }) => (
                <input
                    type="checkbox"
                    checked={selectedRows.includes(row.original._id)}
                    onChange={(e) => handleSelectStage(row.original._id, e.target.checked)}
                />
            ),
            size: 40,
        },
        {
            id: 'drag-handle',
            header: 'No',
            accessorKey: "no",
            cell: ({ row }: { row: Row<stageData> }) => (
                <div onClick={() => setStageDataId(row?.original?._id)}>
                    <Text variant='Poppins14Normal24lh'>{((currentPage - 1) * limit) + row?.index + 1}</Text>
                    <Text {...{
                        onClick: row.getToggleExpandedHandler(),
                        style: { cursor: "pointer", margin: "0px 5px" },
                    }} >
                        {row.getIsExpanded() ? <FaAngleUp /> : <FaAngleDown />}
                    </Text>
                    {location?.search?.includes("CustomOrder") && <RowDragHandleCell row={row} />}
                </div>
            ),
            size: 60,
        },
        {
            header: 'Stage Name',
            accessorKey: "name",
            exportValue: (row: stageData) => row.temporaryName ? row.temporaryName : row.name || '-',
            columns: [],
            cell: ({ row }) => {
                const dueDate = row?.original?.dueDate || '';
                const timeRemaining = row?.original?.timeRemaining || 0;
                return (
                    <StageName
                        stageId={row?.original?._id}
                        stageName={row?.original?.name || ''}
                        temporaryName={row?.original?.temporaryName}
                        dueDate={dueDate}
                        timeRemaining={timeRemaining}
                    />
                );
            },
            filterType: "dropdown",
            options: (parsedQuery.isMEP === 'true'
                ? dataForTable?.data?.allStages?.filter((val: { name: string, isMEP?: boolean }) => val?.isMEP)
                : parsedQuery.isStructural === 'true'
                    ? dataForTable?.data?.allStages?.filter((val: { name: string, isStructural?: boolean }) => val?.isStructural)
                    : parsedQuery.isFireSprinkler === 'true'
                        ? dataForTable?.data?.allStages?.filter((val: { name: string, isFireSprinkler?: boolean }) => val?.isFireSprinkler)
                        : dataForTable?.data?.allStages
            )?.map((val: { _id: string, name: string }) => ({ value: val?.name, label: val?.name }))

        },
        {
            header: 'Project Name',
            accessorKey: "projectId",
            exportValue: (row: stageData) => row.projectId?.name || '-',
            cell: ({ row }) => {
                return (
                    <Paragraph className='project-name-row' >{row.original?.projectId?.name}</Paragraph>
                )
            },
            filterType: 'dropdown',
            options: (() => {
                if (parsedQuery?.status == "Delivered" || parsedQuery?.status == "IPR Delivered") {
                    return masterdataByKeys?.data?.allDeliveredStages?.map((val: { _id: string, name: string }) => ({ value: val?._id, label: val?.name }));
                } else if (parsedQuery?.status == "Ready To Deliver" || parsedQuery?.status == "IPR Ready To Deliver") {
                    return masterdataByKeys?.data?.allRTDStages?.map((val: { _id: string, name: string }) => ({ value: val?._id, label: val?.name }));
                } else if (parsedQuery?.status == "Draft") {
                    return masterdataByKeys?.data?.allDraftStages?.map((val: { _id: string, name: string }) => ({ value: val?._id, label: val?.name }));
                } else {
                    return masterdataByKeys?.data?.allProjects?.map((val: { _id: string, name: string }) => ({ value: val?._id, label: val?.name }));
                }
            })()
        },
        {
            header: 'Folder Number',
            accessorKey: "folderNumber",
            exportValue: (row: stageData) => row.projectId?.folderNumber || '-',
            cell: ({ row }) => {
                return (
                    <Text >{row?.original?.projectId?.folderNumber}</Text>
                )
            },

        },

        {
            header: 'Highlighters',
            accessorKey: "highlighters",
            exportValue: (row: stageData) => row.highlighters?.map((h: { name: string }) => h.name).join("; ") || '-',
            cell: ({ row }) => {
                const stages = row?.original?.highlighters;
                if (stages && stages?.length > 0) {
                    return (
                        <Flex sx={{ justifyContent: "center", flexWrap: 'wrap' }}>
                            {stages?.map((val: { color: string; title?: string; _id: string; name: string }) => (
                                // <CommonSpan color={val?.color} name={val?.name} />
                                <Badge title={val?.name} sx={{ color: `${val?.color}`, border: `1px solid ${val?.color}`, borderRadius: 6, backgroundColor: "transparent", margin: "5px" }} key={val?._id}>{val?.title || val?.name}</Badge>
                            ))}
                        </Flex>
                    );
                } else {
                    return null;
                }
            },
            filterType: 'multi-select-dropdown',
            options: highlighters?.map((val: { _id: string, name: string }) => ({ value: val?._id, label: val?.name }))
        },
        {
            header: 'PM Manager',
            accessorKey: "manager",
            exportValue: (row: stageData) => {
                const pm = row.manager;
                const pmId = typeof pm === 'object' ? (pm as { _id: string })?._id : pm;
                const exists = dataForTable?.data?.allProjectManagers?.some((x: { _id: string }) => x._id === pmId);
                return exists && typeof pm === 'object' && pm ? `${(pm as { FirstName: string }).FirstName || ''} ${(pm as { LastName: string }).LastName || ''}`.trim() || '-' : '-';
            },
            cell: ({ row }) => {
                const pm = row.original.manager;
                const pmId = typeof pm === 'object' ? (pm as { _id: string })?._id : pm;
                const exists = dataForTable?.data?.allProjectManagers?.some((x: { _id: string }) => x._id === pmId);
                return (
                    <Text >{exists && typeof pm === 'object' && pm ? `${(pm as { FirstName: string }).FirstName || ''} ${(pm as { LastName: string }).LastName || ''}`.trim() : ""}</Text>
                )
            },
            filterType: 'dropdown',
            options: dataForTable?.data?.allProjectManagers?.map((val: { _id: string, FirstName: string, LastName: string }) => ({ value: val?._id, label: `${val?.FirstName} ${val?.LastName}` }))
        },
        {
            header: 'Sales Representative',
            accessorKey: "salesRepresentative",
            exportValue: (row: stageData) => {
                const rep = (row.salesRepresentative) as ISalesRepInfo | undefined;
                const repId = typeof rep === 'object' ? rep?._id : rep;
                const salesUserList = (userData?.data || []).filter((user: usersProps) =>
                    user?.departments?.some((dept: { name: string }) => dept?.name === 'SALES')
                );
                const exists = salesUserList.some((u: usersProps) => u._id === repId);
                return exists && rep ? `${rep?.FirstName || ''} ${rep?.LastName || ''}`.trim() || '-' : '-';
            },
            cell: ({ row }: { row: Row<stageData> }) => {
                const rep = (row.original?.salesRepresentative) as ISalesRepInfo | undefined;
                const repId = typeof rep === 'object' ? rep?._id : rep;
                const salesUserList = (userData?.data || []).filter((user: usersProps) =>
                    user?.departments?.some((dept: { name: string }) => dept?.name === 'SALES')
                );
                const exists = salesUserList.some((u: usersProps) => u._id === repId);
                return (
                    <Text>{exists && rep ? `${rep?.FirstName || ''} ${rep?.LastName || ''}`.trim() : ""}</Text>
                )
            },
            filterType: 'multi-select-dropdown',
            options: (userData?.data || [])
                ?.filter((user: usersProps) => user?.departments?.some((dept: { name: string }) => dept?.name === 'SALES'))
                ?.map((val: usersProps) => ({ value: val?._id, label: `${val?.FirstName} ${val?.LastName}` }))
        },
        {
            header: 'Due date',
            accessorKey: "dueDate",
            exportValue: (row: stageData) => formatDueDate(row.dueDate, '-'),
            cell: ({ row }) => {
                const dueDateValue = row.getValue("dueDate") as string;
                return (
                    <Text variant='Poppins14Normal24lh' sx={{ color: colorMode === 'light' ? 'secondary' : '#ffffff' }}>{formatDueDate(dueDateValue)}</Text>
                );
            },
            filterType: 'date',
        },
        {
            header: 'Remaining Time',
            accessorKey: "timeRemaining",
            id: 'timeRemaining',
            exportValue: (row: stageData) => {
                const remainingTime = row.timeRemaining;
                const remainingMs = remainingTime ? +remainingTime : 0;
                const rth = msToTime(remainingMs);
                return `${rth.hours}:${rth.minutes}`;
            },
            cell: ({ row }) => {
                const remainingTime = row.original.timeRemaining;
                const remainingMs = remainingTime ? +remainingTime : 0;
                const rth = msToTime(remainingMs);
                return (
                    <Text >
                        {`${rth.hours}:${rth.minutes}`}
                    </Text>
                );
            },
            enableColumnFilter: true,
            filterType: "estimateBox",
        },
        {
            header: 'Status',
            accessorKey: "status",
            cell: ({ row }) => {
                type StatusType = keyof typeof statusColors;

                const status = row?.original?.status as StatusType;

                const color = statusColors[status] || '#000';

                return (
                    <Badge
                        title={status}
                        sx={{
                            color: `white`,
                            border: `1px solid ${color}`,
                            borderRadius: 6,
                            backgroundColor: `${color}`,
                            margin: "5px"
                        }}
                    >
                        {status}
                    </Badge>
                );
            },
            filterType: 'dropdown',
            options: dataForTable?.data?.status?.map((val: { value: string }) => ({ value: val?.value, label: val?.value }))
        },
        {
            header: 'Promise',
            accessorKey: "promise",
            exportValue: (row: stageData) => {
                const promise = row?.promise;
                return promise ? promise
                    .replace(/([a-z])([A-Z])/g, '$1 $2')
                    .replace(/\b\w/g, (char: string) => char.toUpperCase()) : "-";
            },
            cell: ({ row }) => {
                const promise = row?.original?.promise;
                const camelCasePromise = promise ? promise
                    .replace(/([a-z])([A-Z])/g, '$1 $2')
                    .replace(/\b\w/g, (char: string) => char.toUpperCase()) : "";

                const cellStyle = {
                    backgroundColor: promise === 'hotPromise' ? 'red' : 'transparent',
                    padding: '10px',
                    color: promise === 'hotPromise' ? 'white' : 'inherit',

                };
                return (
                    <div style={cellStyle}>{camelCasePromise}</div>
                )
            },
            filterType: "dropdown",
            options: promiseOptions
        },
        {
            header: 'Tasks Name list',
            accessorKey: "tasksNameList",
            exportValue: (row: stageData) => row.tasksNameList?.map((t: { name: string }) => t.name).join("; ") || '-',
            cell: ({ row }) => {

                const taskList = row.original.tasksNameList;
                return (
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '7px', marginTop: '7px' }}>
                        {taskList?.map((task: { _id: string; color: string; shortForm: string; name: string; status?: string; abtdStatus?: string; timeRemaining?: number }, index: number) => {
                            type StatusType = keyof typeof statusColors;

                            const status = task?.status as StatusType;
                            const color = statusColors[status] || '#000';
                            let timeInHours: string | null = null;

                            if (task.timeRemaining !== undefined) {
                                const totalMilliseconds = task.timeRemaining;

                                const hours = Math.floor(totalMilliseconds / (1000 * 60 * 60));
                                const minutes = Math.floor((totalMilliseconds % (1000 * 60 * 60)) / (1000 * 60));
                                timeInHours = `${hours}:${minutes.toString().padStart(2, '0')}`;
                            }

                            return (
                                <Box key={task._id + "-" + index} sx={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    gap: '7px',
                                    padding: '2px 4px',
                                    backgroundColor: `${color}`,
                                    border: `1px solid ${theme.colors?.black}`,
                                    borderRadius: '6px',
                                    // justifyContent: 'space-evenly'
                                }}>
                                    <Badge
                                        title={task.name}
                                        sx={{
                                            backgroundColor: task.color,
                                            color: `${theme.colors?.white}`,
                                            border: `1px solid ${task.color}`,
                                            borderRadius: '4px',
                                            padding: '1px 4px',
                                            fontSize: '12px',
                                            gap: '4px',
                                            fontWeight: 500
                                        }}
                                    >
                                        {task.shortForm}
                                    </Badge>
                                    {task?.status && (
                                        <Badge
                                            title={task?.status}
                                            sx={{
                                                backgroundColor: `${color}`,
                                                color: `${theme.colors?.white}`,
                                                border: `1px solid ${color}`,
                                                borderRadius: '4px',
                                                gap: '4px',
                                                fontWeight: 500,
                                                padding: '1px 4px',
                                                fontSize: '12px'
                                            }}
                                        >
                                            <Text
                                                sx={{
                                                    display: 'inline-block',
                                                    width: '6px',
                                                    height: '6px',
                                                    background: theme.colors?.white,
                                                    borderRadius: '50%',
                                                    marginRight: '4px',
                                                }}
                                            ></Text>
                                            {task?.abtdStatus}
                                        </Badge>
                                    )}

                                    {timeInHours && (
                                        <Badge
                                            title={timeInHours}
                                            sx={{
                                                backgroundColor: `${theme?.colors?.muted}`,
                                                color: `${theme?.colors?.white}`,
                                                fontWeight: 500,
                                                border: `1px solid ${theme?.colors?.muted}`,
                                                borderRadius: '4px',
                                                padding: '1px 4px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                fontSize: '12px'
                                            }}
                                        >
                                            <img
                                                src={clockIcon}
                                                alt="clock-icon"
                                                style={{ marginRight: '4px', width: '12px', height: '12px' }}
                                            />
                                            {`${timeInHours}h`}
                                        </Badge>
                                    )}
                                </Box>
                            );
                        })
                        }
                    </Box >
                );
            },
        },
        {
            header: 'Total Time Spent',
            accessorKey: "taskSpentList",
            exportValue: (stage: stageData) => {
                const spentList = stage.taskSpentList || [];
                let totalSpent = 0;
                const standardTasksLines = spentList
                    .filter((task: { name?: string; spentTime?: number }) => typeof task.name === 'string' && task.name.includes('(Standard)') && typeof task.spentTime === 'number' && (task.spentTime || 0) > 0)
                    .map((task: { name?: string; spentTime?: number }) => {
                        const spent = task.spentTime || 0;
                        totalSpent += spent;
                        const h = msToTime(spent);
                        return `${(task.name || '').split(' ')[0]}: ${h.hours}:${h.minutes}`;
                    });
                const totalH = msToTime(totalSpent);
                return standardTasksLines.join(" | ") + (totalSpent > 0 ? ` | TOTAL: ${totalH.hours}:${totalH.minutes}` : '-');
            },
            cell: ({ row }: { row: Row<stageData> }) => {
                const spentList = row?.original?.taskSpentList || [];
                let totalSpent = 0;
                const standardTasks = spentList.filter((task: { name?: string }) => typeof task.name === 'string' && task.name.includes('(Standard)'));
                const hasStandardWithSpent = standardTasks.some((task: { spentTime?: number }) => typeof task.spentTime === 'number' && task.spentTime > 0);
                const lines = standardTasks
                    .filter((task: { spentTime?: number }) => typeof task.spentTime === 'number' && (task.spentTime || 0) > 0)
                    .map((task: { name?: string; spentTime?: number }) => {
                        const spent = task.spentTime || 0;
                        totalSpent += spent;
                        // spentTime is in milliseconds
                        const hours = Math.floor(spent / (1000 * 60 * 60));
                        const minutes = Math.floor((spent % (1000 * 60 * 60)) / (1000 * 60));
                        const timeStr = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
                        let shortName = task.name;
                        if (typeof shortName === 'string') {
                            const base = shortName.split(' ')[0].toLowerCase();
                            if (base.startsWith('mech')) shortName = 'Mech';
                            else if (base.startsWith('elec')) shortName = 'Elec';
                            else if (base.startsWith('plum')) shortName = 'Plum';
                            else shortName = base;
                        }
                        return `${shortName}: ${timeStr}`;
                    });
                const totalHours = Math.floor(totalSpent / (1000 * 60 * 60));
                const totalMinutes = Math.floor((totalSpent % (1000 * 60 * 60)) / (1000 * 60));
                const totalTimeStr = `${totalHours.toString().padStart(2, '0')}:${totalMinutes.toString().padStart(2, '0')}`;
                return (
                    <Box
                        sx={{
                            color: colorMode === 'light' ? '#000000' : '#ffffff',
                            fontWeight: 500,
                            fontSize: '13px',
                            background: colorMode === 'light' ? '#ffffff' : '#282e42',
                            display: 'inline-block',
                            textAlign: 'left',
                            minWidth: '120px',
                            // ensure list items inherit color and spacing consistently
                            'ul': {
                                listStyle: 'none',
                                padding: 0,
                                margin: 0,
                                li: {
                                    color: 'inherit',
                                }
                            }
                        }}
                    >
                        <ul>
                            {lines.map((line: string, idx: number) => (
                                <li key={idx}>{line}</li>
                            ))}
                            {hasStandardWithSpent && <li style={{ borderTop: `1px solid ${colorMode === 'light' ? '#000000' : '#ffffff'}`, margin: '3px 0' }}></li>}
                            {hasStandardWithSpent && <li>{`TOTAL: ${totalTimeStr}`}</li>}
                        </ul>
                    </Box>
                );
            },
        },
        {
            header: 'Comments',
            cell: ({ row }) => {
                return (
                    <div>
                        <CommentsDialogBox id={row?.original?._id} comments={row?.original} level="stage" />
                    </div>
                );

            },
        }

    ], [stageView.data, dataForTable, masterdataByKeys, colorMode, selectedRows]);

    const dataIds = useMemo(() => data?.map((item: stageData) => item?._id), [data]);
    const thBackground = colorMode === 'light' ? '#f7efe5' : '#374358';
    const thColor = colorMode === 'light' ? 'black' : '#dadada';
    const table = useReactTable({
        data,
        columns,
        getRowCanExpand: () => true,
        getCoreRowModel: getCoreRowModel(),
        getRowId: useCallback((row: stageData) => row?._id, []),
        getExpandedRowModel: getExpandedRowModel(),
        debugTable: true,
        debugHeaders: true,
        debugColumns: true,

    })

    function handleDragEnd(event: DragEndEvent) {
        const { active, over } = event;

        if (active && over && active.id !== over?.id) {
            const oldData = data?.filter((act: stageData) => act?._id === active?.id);
            const newData = data.filter((ove: stageData) => ove?._id === over?.id);
            const oldDate = new Date(oldData[0]?.dueDate);
            const newDate = new Date(newData[0]?.dueDate);
            if (oldDate.getTime() === newDate.getTime()) {

                const oldIndex = dataIds.indexOf(active.id as string);
                const newIndex = dataIds.indexOf(over.id as string);
                dispatch(GetAllStageViewSuccess({ data: arrayMove(data, oldIndex, newIndex), count: stageView?.count }))

                let isCustOrder1 = location?.search?.includes("stat=CustomOrder1")

                const dispatchObj = {
                    id: oldData?.[0]?._id,
                    stageId2: newData?.[0]?._id,
                    oldOrder: oldData?.[0]?.[isCustOrder1 ? "order1" : "order2"],
                    newOrder: newData?.[0]?.[isCustOrder1 ? "order1" : "order2"],
                    view: isCustOrder1 ? "CustomOrder1" : "CustomOrder2"
                };

                dispatch(getStageByCustomOrder(dispatchObj, (res: { status?: number }) => {

                    if (res?.status === 200) {
                        toast.success("Custom Order Updated Successfully.");
                        setIsLoadingTrue(!isLoadingTrue)
                    }
                }))
            } else {
                toast.error('Due dates are not equal')
            }
        }
    }
    const sensors = useSensors(
        useSensor(MouseSensor, {}),
        useSensor(TouchSensor, {}),
        useSensor(KeyboardSensor, {})

    )

    useEffect(() => {
        if (stageView?.data?.length > 0) {
            setData(stageView?.data || [])

            let newData = stageView?.data?.map((item: stageData) => {
                return { ...item, _id: item?._id, };
            });
            setData(newData)
        } else {
            setData(stageView?.data || [])
        }
    }, [stageView?.data]);

    useEffect(() => {
        if (prevLocationRef.current !== null) {
            const prevSearch = prevLocationRef.current.search;
            const currentSearch = location.search;

            const prevParams = new URLSearchParams(prevSearch);
            const currentParams = new URLSearchParams(currentSearch);

            const prevFilterParams = new URLSearchParams(prevSearch);
            prevFilterParams.delete("limit");
            prevFilterParams.delete("currentPage");

            const currentFilterParams = new URLSearchParams(currentSearch);
            currentFilterParams.delete("limit");
            currentFilterParams.delete("currentPage");

            const filtersEqual = currentFilterParams.toString() === prevFilterParams.toString();

            const limitChanged = prevParams.get("limit") !== currentParams.get("limit");
            const pageChanged = prevParams.get("currentPage") !== currentParams.get("currentPage");

            const hasPaginationParams = currentParams.has("limit") || currentParams.has("currentPage");

            const isPurePaginationChange = filtersEqual && (limitChanged || pageChanged) && hasPaginationParams;

            if (!isPurePaginationChange) {
                setSelectedRows([]);
                setSelectedRowsToExport([]);
            }
        }
        prevLocationRef.current = { search: location.search, pathname: location.pathname };
    }, [location.search, location.pathname, location.key]);

    useEffect(() => {
        let apiEndPoint = getApiEndPoint(
            { limit, currentPage },
            location?.search,
            columns?.map((val) => {
                const c = val as ColumnDef<stageData> & { accessorKey?: string; filterType?: string };
                return { accessorKey: c.accessorKey || '', filterType: c.filterType || '' };
            }) || []
        );
        let manipulateStr = location?.search + apiEndPoint;

        const urlParams = new URLSearchParams(apiEndPoint);
        const isTrue = location?.search?.includes("istrue=true");

        if (isTrue) {
            urlParams.delete('dynamicFilter');
            manipulateStr = urlParams.toString();
            let finalQuery = removeDuplicateQueryParams(location?.search + "&" + manipulateStr);

            dispatch(GetAllStageView(finalQuery));
        } else {
            let queryParams = removeDuplicateQueryParams(apiEndPoint + location?.search?.replace("?", "&"));
            dispatch(GetAllStageView(queryParams));
        }

        const fetchStageTimeSummery = () => {
            if (isTrue) {
                let finalQuery = removeDuplicateQueryParams(location?.search + "&" + manipulateStr);
                dispatch(getStageTimeSummery(finalQuery));
            } else {
                let queryParams = removeDuplicateQueryParams(apiEndPoint + location?.search?.replace("?", "&"));
                dispatch(getStageTimeSummery(queryParams));
            }
        };

        fetchStageTimeSummery();

        const intervalId = setInterval(() => {
            fetchStageTimeSummery();
        }, 30000);


        return () => clearInterval(intervalId);
    }, [location?.search, limit, currentPage]);


    const { data: eventSource } = useQuery({
        queryKey: ['stageSSE'],
        queryFn: () => {
            const eventSource = new EventSource(`${baseUrl}sse/stage`);

            eventSource.onmessage = (event) => {
                try {
                    const data = JSON.parse(event.data);
                    dispatch(UpdateStageRow(data))
                } catch (error) {
                    console.error('Error parsing SSE data:', error);
                }
            };

            eventSource.onerror = (error) => {
                console.error('SSE Error:', error);
                eventSource.close();
            };
            return eventSource;
        },
        refetchInterval: 60000
    })

    useEffect(() => {
        return () => {
            eventSource?.close();
        };
    }, [])


    return (
        <div className='main-content'>
            <TabelHeadingTxt
                Title='Stages view'
                Count={stageView?.count}
                IsExportButtonShow={false}
                addText={'Add Stage'}
                handleClick={handleClick}
                limit={limit}
                currentPage={currentPage}
                columns={columns}
                url={parsedQuery.isMEP === 'true' ? "/stage-view-two?isMEP=true" : parsedQuery.isStructural === 'true' ? "/stage-view-two?isStructural=true" : parsedQuery.isFireSprinkler === 'true' ? "/stage-view-two?isFireSprinkler=true" : "/stage-view-two"}
                summeryTime={true}
                onExportClick={selectedRows.length > 0 ? () => setIsExportModalOpen(true) : undefined}
            />
            <Divider sx={{ color: '#D9D7DD', my: '8px' }} opacity={2} />
            <DndContext
                collisionDetection={closestCenter}
                modifiers={[restrictToVerticalAxis]}
                onDragEnd={(handleDragEnd)}
                sensors={sensors}
            >
                <div className="table-responsive">
                    <Box as="div" sx={{ paddingLeft: '15px', paddingRight: '15px', paddingBottom: '10px' }}>
                        <Box className={`${"tableFixHead"}`} sx={{ borderRadius: 10, border: `1px solid ${theme.colors?.muted}`, minHeight: (loader || data?.length === 0) ? "72vh" : "auto", maxHeight: "72vh !important" }}>
                            <table className={`${'' + TabelClassname?.PrimaryTabel} mb-0 table-hover`}>
                                <thead className="position-relative">
                                    {table.getHeaderGroups()?.map(headerGroup => {

                                        return (
                                            <tr
                                                key={headerGroup.id}
                                                className='trClassName'

                                            >
                                                {headerGroup.headers.map((header: Header<stageData, unknown>, index: number) => {
                                                    const isCommentsHeader = header.column.columnDef.header === "Comments";
                                                    const isSpecialColumn = ["Due date", "TM Worker", "TM Manager", "PM Manager", "Promise", "Stage Name", "Comments", "Status", "Highlighters"].includes(header.column.columnDef.header as string);
                                                    const isTaskNameListHeader = header.column.columnDef.header === "Tasks Name list";
                                                    let headerID = header.getContext().column.id;
                                                    const isNoColumn = header.column.columnDef.header === "No";
                                                    return (
                                                        <th
                                                            className={`th align-middle border-top-0 border-bottom-0 fixed-column-${index} ${(index === 1 && headerID === "drag-handle" && location?.search?.includes("CustomOrder")) ? "th_child" : ""} ${isSpecialColumn ? 'th-quote-number' : ''}${isNoColumn ? 'th-no-column' : ''} ${isTaskNameListHeader ? 'th-task-list' : ''}`}
                                                            key={header.id}
                                                            colSpan={header.colSpan}
                                                            style={{ backgroundColor: thBackground, padding: `${commonPadding}px`, textAlign: 'center', color: thColor }}
                                                        >
                                                            {header.column.getCanFilter() && (
                                                                <FilterPopup column={header.column.columnDef} id={`column${index}`} />
                                                            )}

                                                            {!(header.isPlaceholder) && (
                                                                <Text variant='Poppins16Normal25lh' sx={{ color: colorMode === "light" ? "#0a0a0a" : "#dadada" }} className=" position-relative">
                                                                    {flexRender(header.column.columnDef.header, header.getContext())}
                                                                    {isCommentsHeader && <CommentPopup />}
                                                                </Text>
                                                            )}
                                                        </th>
                                                    );
                                                })}
                                            </tr>
                                        );
                                    })}

                                </thead>
                                <tbody>
                                    <SortableContext items={dataIds} strategy={verticalListSortingStrategy}>
                                        {table.getRowModel()?.rows?.map((row: Row<stageData>) => (
                                            <React.Fragment key={row?.original?._id}>
                                                <DraggableRow row={row} key={row?.original?._id} />
                                                {(row?.original?._id === stageDataId && row.getIsExpanded()) && (
                                                    <tr key={"exp-" + row?.original?._id} className={`table-hover-row ${colorMode === "light" ? "light-mode" : "dark-mode"}`}
                                                    >
                                                        <td colSpan={row.getVisibleCells().length} style={{
                                                            background: colorMode === "light" ? "#fff" : "#282e42",
                                                            color: colorMode === "light" ? "#0a0a0a" : "#dadada"
                                                        }}>
                                                            <StageByTaskView fixedColumn={false} />
                                                        </td>
                                                    </tr>
                                                )}
                                            </React.Fragment>
                                        ))}
                                    </SortableContext>
                                </tbody>
                            </table>
                            {loader &&
                                <Spinner sx={{ position: "absolute", top: "50%", left: "50%" }} />
                            }
                            {!loader && data?.length === 0 && (
                                <Text sx={{ position: "absolute", top: "50%", left: "50%", color: thColor }}>No Data Found!</Text>
                            )}
                        </Box>
                    </Box>
                    <CommonExportModal
                        isOpen={isExportModalOpen}
                        toggle={() => setIsExportModalOpen(!isExportModalOpen)}
                        columns={columns}
                        selectedData={selectedRowsToExport}
                        title="Export Stages"
                        sheetName="Stages"
                        fileNamePrefix="Stages"
                        previewColumns={[
                            { header: 'Stage Name', accessor: (item) => item.name || 'Unnamed Stage' },
                            { header: 'Project Name', accessor: (item) => item.projectId?.name || 'No Project' }
                        ]}
                        onExport={() => {
                            setSelectedRows([]);
                            setSelectedRowsToExport([]);
                        }}
                    />
                    <Box className="sticky-navigation">
                        <TablePagination

                            onPageChange={(value) => {
                                const parsedQuery = queryString.parse(location.search);
                                setSearchParams({
                                    ...parsedQuery,
                                    currentPage: value.toString(),
                                });
                            }}
                            onPerPageChange={(itemsPerPage) => {
                                const parsedQuery = queryString.parse(location.search);
                                setSearchParams({
                                    ...parsedQuery,
                                    currentPage: '1',
                                    limit: itemsPerPage.toString(),
                                });
                            }}
                            perPageCount={limit || 15}
                            TotalLength={stageView?.count || 15}
                            CurrentPage={currentPage}

                        />
                    </Box>
                </div>
            </DndContext>
            {!timeTracking || Object?.keys(timeTracking).length === 0 ? (
                <Button
                    sx={{
                        position: 'fixed',
                        bottom: 20,
                        right: 20,
                        bg: 'primary',
                        color: 'white',
                        borderRadius: '50%',
                        width: 60,
                        height: 60,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        fontSize: 24,
                        boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                        cursor: 'pointer',
                        zIndex: 1000,
                        '&:hover': {
                            bg: 'secondary',
                        }
                    }}
                    onClick={toggleModal}
                >
                    <img
                        src={clockIcon}
                        alt="clock-icon"
                        style={{ width: '40px', height: '40px' }}
                    />
                </Button>
            ) : null}
            <GeneralTimerStart isOpen={modalOpen} toggle={toggleModal} autherId={auther?._id} />
        </div>
    )
}

export default StagesViewTwo;
